export default "<router-outlet></router-outlet> <loader></loader>\n";